<template>
  <div v-if="show" class="bh-modal">
    <!-- Overlay -->
    <div class="bh-overlay" @click="handleClose" />

    <!-- Dialog -->
    <div class="bh-dialog">
      <!-- HEADER -->
      <div class="bh-header">
        <div class="bh-title">Tinjau Foto KTP</div>
        <button style="background: transparent;" @click="handleClose">✕</button>
      </div>

      <div class="bh-divider"></div>

      <!-- BODY -->
      <div class="bh-body">
        <!-- PREVIEW -->
        <div class="preview-box">
          <img v-if="previewUrl" :src="previewUrl" />
        </div>

        <!-- LOADING -->
        <div v-if="loading" class="progress-wrapper">
          <div class="progress-bar">
            <div
              class="progress-fill"
              :style="{ width: progress + '%' }"
            ></div>
          </div>
          <p class="progress-text">
            Memproses foto... {{ progress }}%
          </p>
        </div>

        <!-- ALERT -->
        <div v-if="!loading && type" class="alert" :class="type">
          <span class="icon" v-html="icon"></span>
          <span>{{ message }}</span>
        </div>

        <!-- ACTIONS -->
        <div class="actions">
          <button class="btn-primary" @click="handleUse" :disabled="loading">
            Gunakan Foto Ini
          </button>
          <button class="btn-secondary" @click="$emit('retry')">
            Upload Ulang
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { alertIcons } from '@/assets/icons/alertIcons'

export default {
  name: 'KtpPreviewModal',
  props: {
    show: { type: Boolean, default: false },
    file: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      type: null, // 'warning' | 'error' | null
      message: '',
      cancelToken: null,
      progress: 0
    }
  },
  computed: {
    previewUrl() {
      return this.file ? URL.createObjectURL(this.file) : ''
    },

    icon () {
      return alertIcons[this.type] || alertIcons.info
    }
  },
  watch: {
    show(val) {
      if (val && this.file) {
        this.runOCR()
      } else {
        this.resetState()
      }
    }
  },
  methods: {
    resetState() {
      this.loading = false
      this.type = null
      this.message = ''

      if (this.cancelToken) {
        this.cancelToken.cancel()
      }
    },

    async runOCR() {
      try {
        this.loading = true
        this.type = null
        this.message = ''

        const formData = new FormData()
        formData.append('image', this.file)

        this.cancelToken = axios.CancelToken.source()

        const res = await axios.post('member/ocr', formData, {
          cancelToken: this.cancelToken.token,

          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              )
            }
          }
        })

        const data = res.data

        this.type = null
      } catch (err) {
        const msg = err?.response?.data?.message || 'Terjadi Kesalahan'
        if(msg?.includes('kurang baik')) {
          this.type = 'warning'
          this.message = msg
        } else {
          this.type = 'error'
          this.message = msg
        }
      } finally {
        this.loading = false
      }
    },

    handleUse() {
      this.$emit('use', this.file)
    },

    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.bh-modal {
  position: fixed;
  inset: 0;
  z-index: 99999;
}

.bh-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
}

.bh-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(520px, calc(100% - 32px));
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
}

.bh-header {
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  font-weight: 700;
}

.bh-divider {
  height: 1px;
  background: #e5e7eb;
}

.bh-body {
  padding: 16px;
}

/* preview */
.preview-box {
  border: 2px dashed #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  align-items: center;

  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-box img {
  max-width: 100%;
  max-height: 400px;
  border-radius: 8px;
  align-items: center;
}

/* loading */
.ocr-loading {
  margin-top: 16px;
  font-size: 14px;
  color: #6b7280;
}

/* alert */
.alert {
  margin-top: 16px;
  padding: 14px;
  border-radius: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  color: white;
  font-size: 14px;
}

.alert.warning {
  background: #EB9A3F;
}

.alert.error {
  background: #EE3D22;
}

/* actions */
.actions {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-primary {
  background: #1f3c88;
  color: white;
  font-weight: 600;
  padding: 14px;
  border-radius: 8px;
}

.btn-secondary {
  color: #1f3c88;
  font-weight: 600;
  border: 1px solid #cbd5e1;
  padding: 14px;
  border-radius: 8px;
  background: white;
}

.progress-wrapper {
  margin-top: 16px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #1f3c88;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 12px;
  margin-top: 6px;
  color: #6b7280;
  text-align: center;
}
</style>
